<template>
  <div class="pro_item" :class="{ width100: type == 'lazyloading' }">
    <div class="img" @click="goDetail">
      <img v-lazy="prolistItem.img_path" />
      <img
        src="/static/images/shouqing.png"
        class="soldout"
        v-if="islimit == 2"
      />
      <img
        src="../../assets/images/soldout.png"
        class="soldout"
        v-else-if="issale == 0"
      />
    </div>
    <div class="tit" @click="goDetail">
      {{
        prolistItem.name.length > 26
          ? prolistItem.name.slice(0, 26) + '...'
          : prolistItem.name
      }}
    </div>
    <div class="price" @click="goDetail">
      <label class="xian">
        <sub>¥</sub>
        <b>{{
          String(prolistItem.sales_price).slice(
            0,
            String(prolistItem.sales_price).indexOf('.')
          )
        }}</b>
        <sup>{{
          String(prolistItem.sales_price).slice(
            String(prolistItem.sales_price).indexOf('.'),
            String(prolistItem.sales_price).length
          )
        }}</sup>
      </label>
      <label class="yuan">¥{{ prolistItem.cost_price }}</label>
      <div
        v-if="skuSwitch == '1'"
        class="opensku"
        @click.stop="openSku(prolistItem, prolistIndex)"
      >
        <img src="/static/images/index/cart.png" />
      </div>
    </div>
    <ul class="integralTags" @click="goDetail">
      <li v-if="prolistItem.taglist" v-for="item of prolistItem.taglist">
        {{ item }}
      </li>
    </ul>
    <div class="desc" @click="goDetail">
      <div class="l">
        已售{{
          parseFloat(prolistItem.sales_num) / 10000 >= 1
            ? (parseInt(parseInt(prolistItem.sales_num) / 100) / 100).toFixed(
                2
              ) + 'w'
            : prolistItem.sales_num
        }}
      </div>
      <div class="r">好评{{ prolistItem.comment_num }}</div>
    </div>
    <van-sku
      v-if="skuSwitch == '1'"
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :quota-used="quotaUsed"
      :goods-id="productId"
      :quota="quota"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span
              ><span class="van-sku__price-num">{{ skuprice }}</span>
              <span class="van-sku__costprice-symbol">¥</span
              ><span class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure yellow"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(0)"
          >
            加入购物车
          </van-button>
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(1)"
          >
            立即购买
          </van-button>
        </div>
      </template>
    </van-sku>
  </div>
</template>

<script>
import {
  isWeixin,
  isApp,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import { Sku } from 'vant'
import wx from 'weixin-js-sdk'
export default {
  name: 'productItem',
  components: {
    [Sku.name]: Sku
  },
  props: {
    markPointData: {
      // 埋点用
      type: Object,
      default: function() {
        return {}
      }
    },
    prolistItem: {
      type: Object,
      default: function() {
        return {}
      }
    },
    prolistIndex: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    skuSwitch: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      daiIndex: 0,
      zcIndex: 0,
      sureGray: false,
      skuprice: '197.00-218.90',
      skucostprice: '',
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      productId: null,
      showsku: false,
      skuname: '',
      i: 0,
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      skuValueToast: null,
      islimit: 0,
      issale: 1
    }
  },
  watch: {
    showsku(n) {
      this.$emit('showSku', n)
    }
  },
  mounted: function() {
    if (
      this.prolistItem.sku_rule_list &&
      this.prolistItem.sku_rule_list.length > 0
    ) {
      let i = 0,
        j = 0
      this.prolistItem.sku_rule_list.map((item) => {
        if (item.islimit == 2) i++
        if (item.issale == 0) j++
      })
      if (i == this.prolistItem.sku_rule_list.length) this.islimit = 2
      if (j == this.prolistItem.sku_rule_list.length) this.issale = 0
    } else {
      if (typeof this.prolistItem.islimit != 'undefined')
        this.islimit = this.prolistItem.islimit
      if (typeof this.prolistItem.issale != 'undefined')
        this.issale = this.prolistItem.issale
    }
  },
  methods: {
    goDetail() {
      var id = this.prolistItem.itemid
        ? this.prolistItem.itemid
        : this.prolistItem.item_base_id
      var that = this
      if (this.type != 'lazyloading' && this.type != 'notScrollTo') {
        // window.scrollTo(0, 0)
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'indexprod-' + id
          },
          callback: () => {
            f()
          }
        })
        return
      }
      f()
      function f() {
        let data = that.markPointData
        data.itemid = id
        that.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: data
        })
        if (
          that.prolistItem.product_detail &&
          that.prolistItem.product_detail == 1
        ) {
          that.$router.replace({
            path: '/productdetail',
            query: {
              itemid: id
            }
          })
          that.$emit('itemid', that.prolistItem.item_base_id)
        } else {
          var arg = isApp()

          if (arg == '') {
            that.$router.push({
              path: '/productdetail',
              query: {
                itemid: id
              }
            })
          } else if (arg.indexOf('xcx') < 0) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'goItemDetail',
                itembaseid: id
              })
            )
          } else {
            wx.miniProgram.navigateTo({
              url:
                '/pages/product/main?itemid=' +
                id +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          }
        }
      }
      // this.$router.go()
      // window.location.href = '/productdetail?itemid=' + id
    },
    openSku(items, idx) {
      var that = this
      that.daiIndex = 0
      that.zcIndex = 0
      items.sku_rule_list.map(function(item) {
        if (item.issale == 1 && item.canbuycnt > 0) {
          if (item.islimit == 1) {
            // 待售
            that.daiIndex++
          } else if (item.islimit == 0) {
            that.zcIndex++
          }
        }
      })
      if (that.zcIndex <= 0 && that.daiIndex <= 0) {
        this.$toast('当前商品无货')
        return
      }
      this.productNum = items.num
      this.listItem = items
      this.itemIndex = idx
      this.productId = this.listItem.itemid
      this.maxNum = parseInt(this.listItem.canbuycnt)
      this.goods.title = items.name
      this.skuprice = parseFloat(items.sales_price).toFixed(2)
      this.skucostprice = parseFloat(items.cost_price).toFixed(2)
      this.goods.picture = items.img_path
      this.skuname = items.spec
      // console.log('skuValueToast:', that.skuValueToast)
      if (
        !that.skuValueToast ||
        !that.skuValueToast.selectedSkuComb ||
        that.skuValueToast.selectedSkuComb.stock_num <= 0
      ) {
        that.goods.picture = items.img_path
        that.skuname = ''
        that.sureGray = true
        that.i = 0
      }
      var arg = isApp()
      if (!isWeixin()) {
        if (
          that.waptoken.waptoken &&
          that.waptoken.waptoken == that.waptoken.tourists &&
          arg == ''
        ) {
          that.$store.commit(
            'PATH_VALUE',
            JSON.stringify({ itemid: that.$route.query.itemid })
          )
          that.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          that.sku.list = []
          that.sku.tree = []
          items.normlist.map(function(item, index) {
            that.sku.tree.push({
              k: item.spec_classify_name,
              v: [],
              k_s: 's' + (index + 1)
            })
            item.speclist.map(function(itemSon) {
              that.sku.tree[index].v.push({
                id: itemSon.spec_id,
                name: itemSon.spec_name
              })
            })
          })
          items.sku_rule_list.map(function(item) {
            // if (item.issale === 1 && item.islimit === 0) {
            var stockNum =
              item.issale == 0 || item.islimit == 2 || item.is_can_buy == 0
                ? 0
                : parseInt(item.canbuycnt)
            that.sku.list.push({
              id: item.skuid,
              price: item.sales_price,
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              stock_num: stockNum,
              cost_price: item.cost_price
            })
            if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
              if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
                that.skuValueToast.selectedSkuComb.stock_num = stockNum
                if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                  that.goods.picture = items.img_main_path
                  that.skuname = ''
                  that.sureGray = true
                }
              }
            }
            that.sku.stock_num += stockNum
            if (stockNum > 0) {
              that.skuname = item.sku_name
              that.goods.picture = item.spec_imgpath
              that.goods.isdiscount = item.isdiscount
              that.goods.isfullgift = item.isfullgift
              that.goods.payfreight = item.freightrule.payfreight
              that.goods.ispresale = item.ispresale
              that.goods.presaletime = item.presaletime
              that.initialSku = {
                s1: item.spec_group_id.split('_')[0],
                s2: item.spec_group_id.split('_')[1],
                s3: item.spec_group_id.split('_')[2],
                payfreight: item.freightrule.payfreight,
                isdiscount: item.isdiscount,
                isfullgift: item.isfullgift,
                ispresale: item.ispresale,
                presaletime: item.presaletime,
                selectedNum: 1
              }
            }
            // }
          })
          // console.log('this.skuprice:', that.skuprice)
          this.showsku = true
        }
      } else {
        that.sku.tree = []
        that.sku.list = []
        items.normlist.map(function(item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function(itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        items.sku_rule_list.map(function(item) {
          // if (item.issale === 1 && item.islimit === 0) {
          var stockNum =
            item.issale == 0 || item.islimit == 2 ? 0 : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: item.sales_price,
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            payfreight: item.freightrule.payfreight,
            isdiscount: item.isdiscount,
            isfullgift: item.isfullgift,
            ispresale: item.ispresale,
            presaletime: item.presaletime,
            stock_num: stockNum,
            cost_price: item.cost_price
          })
          if (that.skuValueToast && that.skuValueToast.selectedSkuComb) {
            if (that.skuValueToast.selectedSkuComb.id == item.skuid) {
              that.skuValueToast.selectedSkuComb.stock_num = stockNum
              if (that.skuValueToast.selectedSkuComb.stock_num <= 0) {
                that.goods.picture = items.img_main_path
                that.skuname = ''
                that.sureGray = true
              }
            }
          }
          that.sku.stock_num += stockNum
          if (stockNum > 0 && that.i == 0) {
            that.skuname = item.sku_name
            that.goods.picture = item.spec_imgpath
            that.goods.isdiscount = item.isdiscount
            that.goods.isfullgift = item.isfullgift
            that.goods.payfreight = item.freightrule.payfreight
            that.goods.ispresale = item.ispresale
            that.goods.presaletime = item.presaletime
            that.initialSku = {
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              payfreight: item.freightrule.payfreight,
              isdiscount: item.isdiscount,
              isfullgift: item.isfullgift,
              ispresale: item.ispresale,
              presaletime: item.presaletime,
              selectedNum: 1
            }
            that.i = 1
          } else if (stockNum <= 0 && that.i == 0) {
            that.skuprice = parseFloat(items.sales_price).toFixed(2)
            that.skucostprice = parseFloat(items.cost_price).toFixed(2)
            // if (parseFloat(items.sales_top_price) != parseFloat(items.sales_bottom_price)) {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2) + '-' + parseFloat(items.sales_top_price).toFixed(2)
            // } else {
            //   that.skuprice = parseFloat(items.sales_bottom_price).toFixed(2)
            // }
            // that.initialSku = {}
            that.i = 1
          }
          // }
        })
        this.showsku = true
      }
    },
    checkedSku(skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      this.skuValueToast = skuValue
      console.log(skuValue.selectedSkuComb)
      if (skuValue.selectedSkuComb) {
        this.customStepperConfig.stockNum = this.quota =
          skuValue.selectedSkuComb.stock_num
      } else {
        this.customStepperConfig.stockNum = this.quota = 0
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      this.goods.isdiscount = 0
      this.goods.isfullgift = 0
      this.goods.payfreight = 0
      this.goods.ispresale = 0
      this.goods.presaletime = ''
      Object.keys(skuValue.selectedSku).forEach(function(key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr =
            skuStr == ''
              ? skuValue.selectedSku[key]
              : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            this.goods.isdiscount = len[i].isdiscount
            this.goods.isfullgift = len[i].isfullgift
            this.goods.payfreight = len[i].freightrule.payfreight
            this.goods.ispresale = len[i].ispresale
            this.goods.presaletime = len[i].presaletime
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(
                skuValue.selectedSkuComb.price
              ).toFixed(2)
              this.skucostprice = parseFloat(
                skuValue.selectedSkuComb.cost_price
              ).toFixed(2)
            }
            break
          }
        }
      } else {
        this.skuprice = parseFloat(this.listItem.sales_price).toFixed(2)
        this.skucostprice = parseFloat(this.listItem.cost_price).toFixed(2)
        // if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2) + '-' + parseFloat(this.listItem.sales_high_price).toFixed(2)
        // } else {
        //   this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        // }
      }
      console.log(skuValue, 'that.initialSku', this.initialSku)
    },
    onConfirmClicked(type) {
      this.buyType = type
      if (this.sureGray) {
        return
      }

      // 1立即购买，0加入购物车
      let dataType = this.buyType == 1 ? 'buyNow' : 'addToCart'
      this.dataCollection(dataType)
      var skuData = this.$refs.sku.getSkuData()
      var that = this
      if (skuData.selectedSkuComb !== null) {
        that.showsku = false
        that.skuId = skuData.selectedSkuComb.id
        if (skuData.selectedNum == 0) {
          skuData.selectedNum = 1
        }
        that.itemnum = skuData.selectedNum
        var urlCheck =
          that.$ajax.checkOrder_URL +
          '?skuids=' +
          that.skuId +
          '&buynum=' +
          that.itemnum
        var urlShop = that.$ajax.addShoppingCart_URL
        var data = {
          skuid: that.skuId,
          itemnum: that.itemnum
        }
        if (!that.buyType) {
          console.log(data)
          that.$customRequestAjax.post(urlShop, data).then((res) => {
            if (res.data.code === 200) {
              that.$store.commit('ADD_CART_INIT_DATA', 1)
              that.$commonburiedPoint({
                data: {
                  isaddcart: 1,
                  itemid: that.skuId,
                  skuid: that.skuId
                }
              })
              that.$toast('已成功加入购物车')
              if (that.$route.path == '/cart') {
                that.$emit('addCartHandler')
              }
            }
          })
        } else {
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code === 200) {
              let currentdiscount =
                skuData.selectedSkuComb.isdiscount == 1
                  ? that.currentdiscount
                  : 1
              var shopConfirmResult = {
                skuidArr: [],
                from: 2,
                orderfrom: 1,
                liveId: that.prolistItem.liveid
                  ? [that.prolistItem.liveid]
                  : [],
                itemNum: [],
                totalmoney:
                  parseFloat(skuData.selectedSkuComb.price) *
                  skuData.selectedNum *
                  currentdiscount,
                totalnum: skuData.selectedNum
              }
              shopConfirmResult.skuidArr.push(that.skuId)
              shopConfirmResult.itemNum.push(that.itemnum)
              localStorage.setItem(
                'shopConfirmResult',
                JSON.stringify(shopConfirmResult)
              )
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              var arg = isApp()
              if (arg == '') {
                that.$router.push('/order')
              } else if (arg != '' && arg.indexOf('xcx') < 0) {
                var obj = {
                  type: 'addToConfirmOrder',
                  skuids: shopConfirmResult.skuidArr.join(),
                  item_num: shopConfirmResult.itemNum.join(),
                  from: shopConfirmResult.from
                }
                that.$commonburiedPoint({
                  data: {
                    scenepoint: window.document.title,
                    scenedesc: window.location.href,
                    url: 'order-confirm'
                  },
                  rnType: 'addToConfirmOrder',
                  callback: () => {
                    window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                  }
                })
              } else {
                shopConfirmResult.orderHadOnShow = 0
                shopConfirmResult.isInitData = 1
                shopConfirmResult.live_id = ''
                shopConfirmResult.type = 'addToConfirmOrder'
                wx.miniProgram.navigateTo({
                  url:
                    '/pages/order/main?shopConfirmResult=' +
                    JSON.stringify(shopConfirmResult) +
                    '&scenepoint=' +
                    encodeURIComponent(window.document.title) +
                    '&exclusiveid=' +
                    exclusiveidFn() +
                    pointParams('&')
                })
              }
            }
          })
        }
      }
    },
    // 埋点
    dataCollection(dataType) {
      let params = {
        productId_var: this.listItem.itemid,
        productName_var: this.listItem.name,
        firstCat_var: this.listItem.brand,
        productType_var: '',
        productFormat_var: this.skuId
      }
      console.log(dataType, params)
      gio('track', dataType, params)
    }
  }
}
</script>

<style scoped lang="scss">
.pro_item {
  width: 50%;
  /*height: 2.74rem;*/
  margin-bottom: 0.16rem;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &.width100 {
    width: 100%;
    background: #ffffff;
    overflow: hidden;
    border-radius: 0.1rem;
    margin-bottom: 0.12rem;
    .tit,
    .desc {
      margin: 0.08rem 0.07rem;
    }
    .tit {
      margin-bottom: 0;
      height: auto;
    }
    .integralTags,
    .price {
      margin: 0 0.07rem;
    }
    .desc {
      margin-top: 0;
      overflow: hidden;
    }
  }
  .img {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    /*height: 1.73rem;*/
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      /*height: 100%;*/
    }
    .soldout {
      width: 59%;
      height: 59%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .tit {
    margin-top: 0.12rem;
    font-size: 0.13rem;
    line-height: 0.18rem;
    height: 0.36rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #292929;
  }
  .integralTags {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: -0.07rem !important;
    margin-bottom: 0.04rem !important;
    li {
      margin: 0;
      border: 0.01rem solid #ff655a;
      border-radius: 0.03rem;
      color: #ff655a;
      font-size: 0.08rem;
      padding: 0.01rem 0.03rem;
      width: auto;
      margin-right: 0.05rem;
      margin-top: 0.03rem;
    }
  }
  .price {
    margin-top: 0.1rem;
    font-size: 0.14rem;
    overflow: hidden;
    .xian {
      color: #fc0324;
      font-size: 0;
      line-height: 0.2rem;
      b {
        font-size: 0.14rem;
        font-weight: 600;
      }
      sub {
        font-weight: normal;
        font-size: 0.12rem;
        vertical-align: baseline;
      }
      sup {
        font-size: 0.11rem;
        vertical-align: baseline;
        font-weight: normal;
      }
    }
    .yuan {
      font-size: 0.12rem;
      transform: scale(0.85);
      color: #6c6c6c;
      text-decoration: line-through;
    }
    .opensku {
      width: 0.19rem;
      height: 0.19rem;
      float: right;
      img {
        width: 100%;
      }
    }
  }
  .desc {
    font-size: 0.11rem;
    line-height: 0.16rem;
    color: #6c6c6c;
    /*margin-top: -0.06rem;*/
    .l {
      float: left;
    }
    .r {
      float: right;
    }
  }
}
</style>

<style lang="scss">
.pro_item {
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
  .van-button--danger.sure {
    background: linear-gradient(90deg, #f63a66 0%, #fc0324 100%);
  }
  .van-button--danger.yellow {
    background: linear-gradient(90deg, #ffa700 0%, #ffba00 100%);
  }
}
.pro_item {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku__costprice-symbol {
    margin-left: 0.05rem;
  }
  .good_sku .van-sku__costprice-symbol,
  .van-sku__costprice-num {
    font-size: 0.12rem;
    color: #979797;
    font-weight: normal;
    line-height: 0.2rem;
    text-decoration: line-through;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
    padding-bottom: 0.6rem;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/productItem.vue